import React from 'react';
import IntroSection from '../components/IntroSection';
import HumanCentricSection from '../components/HumanCentricSection';
import CareersMean from '../components/CareersMean';
import CareerWorking from '../components/CareerWorking';
import CareerPart from '../components/CareerPart';
import CareerHow from '../components/CareerHow';
import CareerSelection from '../components/CareerSelection';
import BlueSectionDivider from '../components/BlueSectionDivider';
import Footer from '../components/Footer';

const Careers =()=>{
    return (
        <div>
            <IntroSection title="THERE'S A BETTER WAY TO WORK" paragraph="Working here, you'll be empowered at every level to do your very best work." backgroundImage="/images/about-bg.webp"/>
            <HumanCentricSection/>
            <CareersMean/>
            <CareerWorking/>
            <CareerPart/>
            <CareerHow/>
            <CareerSelection/>
            <BlueSectionDivider/>
            <Footer/>

        </div>
    )
}
export default Careers;